import { Injectable } from '@angular/core';
import * as moment from 'moment';
import Employee from 'src/app/model/product/employee';

@Injectable({
  providedIn: 'root'
})
export class EmployeeTourEditInputStoreService {
  private employeeTourEditInputMap = new Map<number, EmployeeTourEditInput>();

  storeEmployeeTourEditInput(
    subProjectId: number,
    input: EmployeeTourEditInput
  ): void {
    const error = this.validateEmployeeTourEditInput(input);
    if (error) {
      throw new Error(error);
    }
    this.employeeTourEditInputMap.set(subProjectId, input);
  }

  hasEmployeeTourEditInputForSubProject(subProjectId: number): boolean {
    return this.employeeTourEditInputMap.has(subProjectId);
  }

  consumeEmployeeTourEditInput(subProjectId: number): EmployeeTourEditInput {
    const toReturn: EmployeeTourEditInput = this.employeeTourEditInputMap.get(
      subProjectId
    );
    this.employeeTourEditInputMap.delete(subProjectId);
    return toReturn;
  }

  private validateEmployeeTourEditInput(input: EmployeeTourEditInput): string {
    if (input == null) {
      return 'input cannot be null';
    }
    if (input.placer == null) {
      return 'placer cannot be null';
    }
    if (input.tourId == null) {
      return 'tourId cannot be null';
    }
    if (input.tourDate == null) {
      return 'tourDate cannot be null';
    }
    if (input.placerOptions == null) {
      return 'placerOptions cannot be null';
    }
  }
}

export interface EmployeeTourEditInput {
  placer: Employee;

  tourId: number;

  tourDate: moment.Moment;

  placerOptions: Employee[];
}
